module.exports = __webpack_public_path__ + "media/images/Politique d’achats responsables-3b46f68972b514f7d6a7f2381ea6ae9b.svg";